import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { FONT_BODY, FONT_DISPLAY, Reveal, SectionHeading, TEAL, glassCardSx, gridLayerSx } from './LandingKit';

const RED = '#e5484d';

const stats = [
  {
    value: '+90%',
    accent: TEAL,
    label: 'do rastreamento no automático',
    description:
      'A equipe para de lançar posição e status na mão. O rastreamento roda sozinho, no celular do motorista.',
  },
  {
    value: 'R$ 22.500/mês',
    accent: RED,
    label: 'é o que custa rastrear 50 veículos com aparelho',
    description:
      'A R$ 450 por veículo. No DriveSync esse custo de hardware vai a zero: nada de aparelho para comprar, instalar ou manter.',
  },
];

export default function Results() {
  return (
    <Box id="results" sx={{ position: 'relative', overflow: 'hidden' }}>
      <Box aria-hidden sx={gridLayerSx} />
      <Container sx={{ position: 'relative', py: { xs: 8, sm: 14 } }}>
        <Reveal>
          <Box sx={{ mb: { xs: 5, sm: 7 } }}>
            <SectionHeading
              overline="RESULTADOS"
              align="center"
              title="Menos hardware, mais operação no automático"
              subtitle="Os números que fazem a conta fechar."
            />
          </Box>
        </Reveal>
        <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
          {stats.map((stat, i) => (
            <Grid size={{ xs: 12, md: 5 }} key={stat.label}>
              <Reveal delay={i * 0.08} sx={{ height: '100%' }}>
                <Stack
                  component={Card}
                  elevation={0}
                  spacing={1.5}
                  useFlexGap
                  sx={(theme) => ({ ...glassCardSx(theme), p: { xs: 3, sm: 4 }, height: '100%' })}
                >
                  <Typography
                    component="p"
                    sx={{
                      fontFamily: FONT_DISPLAY,
                      fontWeight: 800,
                      letterSpacing: '-0.02em',
                      lineHeight: 1,
                      whiteSpace: 'nowrap',
                      fontSize: 'clamp(1.7rem, 3.4vw, 2.6rem)',
                      color: stat.accent,
                      textShadow: `0 0 32px ${stat.accent}40`,
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    sx={(theme) => ({
                      fontFamily: FONT_DISPLAY,
                      fontWeight: 700,
                      fontSize: '1.05rem',
                      letterSpacing: '-0.01em',
                      color: '#071513',
                      ...theme.applyStyles('dark', { color: '#f2fbf9' }),
                    })}
                  >
                    {stat.label}
                  </Typography>
                  <Typography
                    sx={(theme) => ({
                      fontFamily: FONT_BODY,
                      fontSize: '0.95rem',
                      lineHeight: 1.5,
                      color: '#33514c',
                      ...theme.applyStyles('dark', { color: '#9fc4bd' }),
                    })}
                  >
                    {stat.description}
                  </Typography>
                </Stack>
              </Reveal>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
